import '@vibe/core/tokens';
import { Loader } from '@vibe/core';

function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        minHeight: 'inherit',
      }}
    >
      <Loader size="medium" color="dark" />
    </div>
  );
}

export default Loading;
